import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const SingleArrowRight = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <g id={'guts'}>
        <path
            d='M8.90991 19.92L15.4299 13.4C16.1999 12.63 16.1999 11.37 15.4299 10.6L8.90991 4.08'
            strokeWidth={strokeWidth}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </g>;
};

export default createSvg(
    SingleArrowRight,
    'single-arrow-right',
);
